const connections = {
    urlDev: 'https://hdltechnology.com.mx/capacitacion/api/index.php',
    urlProd: 'https://hdltechnology.com.mx/sistema/api/index.php',
}


const cDocuments = {
    urlDev: 'https://hdltechnology.com.mx/capacitacion/api/files',
    urlProd: 'https://hdltechnology.com.mx/sistema/api/files/',
}


const icosIndicators = {
 active: './assets/images/indicators/active.png',
 close: './assets/images/indicators/orderSuccess.png',
 error: './assets/images/indicators/error.png',
 warranty: './assets/images/indicators/warranty.png',
 earnings: './assets/images/indicators/earnings.png',

 sales: './assets/images/indicators/sales.png',
 orders: './assets/images/indicators/orders.png',
 devices: './assets/images/indicators/devices.png',
 memberships: './assets/images/indicators/form.png',
 checklist: './assets/images/indicators/checklist.png',
}

const images = {
    logo: './assets/images/logo.png',
};






export { connections,cDocuments,icosIndicators,images };